import AddClinicalEvent from './Actions/AddClinicalEvent';

const EmptyEvents = () => {
  return (
    <>
      <div className={'mb-6 text-neutrals-n-300 text-base'}>
        Here you can add a new RTM clinical event for your patient with the ability to track and
        edit it if needed.
      </div>
      <AddClinicalEvent isEmptyEvents={true} />
    </>
  );
};

export default EmptyEvents;
